import ResourceConfig from './ResourceConfig';
import GalleryConfig from './GalleryConfig';

export default class DirectoryConfig extends ResourceConfig {
  public gallery(): GalleryConfig | undefined {
    if (!this.has('gallery')) {
      return;
    }

    return new GalleryConfig(this.get('gallery'));
  }
}
